import React, { useState, useEffect } from "react";
import PopupModelCenter, {
  PopupModelProps
} from "../../../../components/popup-model-center";
import { getOrderBillingMsg, incomeDetail } from "../../api";
import { getParamsFromHash } from "../../../../utils/common";
import ContactService from "../../../../components/contact-service";
import Loading from "../../../../components/loading";
import { CHARGE_CDN, isMyApp } from "../../../../utils/constants";
import SharePanel from "../../../../components/share-panel";
import { getTitleObj } from "../../utils";
import {
  SettleTypeEnum,
  OrderStatusEnum,
  ReceiptStatusEnum
} from "../../types";

import "./index.less";
import { trackGdp } from "../../../../utils/gio-report";
import { ExclamationCircleOutline } from "antd-mobile-icons";
import PopupBottomModal from "../../../../components/popup-bottom-modal";
import PriceList, { Price } from "../../../../components/price-list";

const OrderDetail = () => {
  const [orderDetail, setOrderDetail] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [priceListData, setPriceListData] = useState<Price[]>([]);
  const [priceListPopupVisible, setPriceListPopupVisible] = useState(false);
  const [sharePanelVisible, setSharePanelVisible] = useState(false);
  const [popupModelData, setPopupModelData] = useState<PopupModelProps>({});
  const isReceived =
    orderDetail?.settleType !== SettleTypeEnum.OFFLINE &&
    orderDetail?.orderStatus !== OrderStatusEnum.WAIT_PAY &&
    orderDetail?.receiptStatus === ReceiptStatusEnum.RECEIPTED;

  /**
   * 将分钟数转化为目标时间格式
   * @param min
   * @returns
   */
  const formatMinToHm = (min: number) => {
    if (!min) return "--";

    const h = Math.floor(min / 60);
    const m = min % 60;

    if (h <= 0) return `${m}分钟`;
    return `${h}小时${m}分钟`;
  };

  const orderInfoList = () => {
    return [
      {
        name: "订单编号",
        value: orderDetail?.orderNo
      },
      {
        name: "下单时间",
        value: orderDetail?.applyTime
      },
      {
        name: "支付方式",
        value: orderDetail?.settleTypeStr
      },
      {
        name: "支付时间",
        value: orderDetail?.payTime
      }
    ];
  };

  const chargeInfoList = () => {
    return [
      {
        name: "充电时长",
        value: formatMinToHm(orderDetail?.chargeTimes)
      },
      {
        name: "充电量",
        value: orderDetail?.energy
      },
      {
        name: "充电开始时间",
        value: orderDetail?.bgnTime
      },
      {
        name: "充电结束时间",
        value: orderDetail?.endTime
      },
      {
        name: "拔枪时间",
        value: orderDetail?.pullGunTime
      },
      {
        name: "停止原因",
        value: orderDetail?.stopReasonStr
      }
    ];
  };

  // 加密手机号
  const encryptMobile = mobile => {
    if (!mobile) return "";
    return mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
  };
  const toGetOrderBillingMsg = async () => {
    const orderNo = getParamsFromHash("orderNo");
    const userId = getParamsFromHash("uid");
    try {
      const { data, code } = await getOrderBillingMsg({
        custId: userId,
        orderNo: orderNo
      });
      if (![0, 200].includes(code) || !data) {
        return
      }
      setPriceListData(data.orderBillingPeriodDtoList.map(v=>({
        startTime: v.startTime,
        endTime: v.endTime,
        servicePrice: v.finalServicePrice
      })))
      setPriceListPopupVisible(true)
    } catch (error) {
      console.error(error)
    }
    
  }
  useEffect(() => {
    document.title = "收益明细";
    trackGdp("P20147", "B001");
    const orderNo = getParamsFromHash("orderNo");
    console.log("first orderNo:", orderNo);
    // -调用接口获取订单详情
    incomeDetail({ orderNo })
      .then(res => {
        if ([0, 200].includes(res.code)) {
          setOrderDetail(res.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const remind = () => {
    trackGdp("P20147", "B002");
    setSharePanelVisible(true);
  };

  const checkRule = () => {
    setVisible(true);
    setPopupModelData({
      popupTitle: "温馨提示",
      content: (
        <div>
          支付渠道手续费最高为订单金额0.6%，该金额由微信/支付宝收取，具体费率取决于支付渠道。
        </div>
      ),
      rightBtnText: "知道了",
      rightBtnFun: () => {
        setVisible(false);
      }
    });
  };
  return loading ? (
    <Loading />
  ) : (
    <div className="order-detail-content">
      {orderDetail.settleType !== SettleTypeEnum.OFFLINE && (
        <div
          className="title"
          style={{ color: getTitleObj(orderDetail).color }}
        >
          {getTitleObj(orderDetail).title}
        </div>
      )}
      {orderDetail.orderStatus !== OrderStatusEnum.WAIT_PAY && (
        <div className="info-content">
          <div className="info-title">收益信息</div>
          <div className="info-item">
            <div className="left">订单金额</div>
            <div className="right order-detail-content-detail-right" onClick={toGetOrderBillingMsg}>
              <span className="order-detail-content-detail-icon">价格详情</span>
                <img
                  src={
                    "https://s.xiaopeng.com/xp-charge/mini/common/grey_guide.png"
                  }
                  alt=""
                />
              <span>{orderDetail.totalAmt}</span>
            </div>
          </div>
          <div className="info-item">
            <div className="left">平台服务费</div>
            <div className="right">限时免费</div>
          </div>
          {// 订单为个人结算且订单状态为已完成时展示支付渠道手续费
          orderDetail?.settleType === SettleTypeEnum.PERSONAL &&
            orderDetail?.orderStatus === OrderStatusEnum.FINISHED && (
          <div className="info-item">
                <div className="left" onClick={checkRule}>
                  支付渠道手续费
                  <img
                    onContextMenu={(e) => e.preventDefault()} 
                    src={
                      "https://s.xiaopeng.com/xp-charge/mini/common/grey_guide.png"
                    }
                    alt=""
                  />
                </div>
                <div className="right">
                  {isReceived ? orderDetail.premiumAmt || "计算中" : "计算中"}
                </div>
              </div>
            )}    
          {orderDetail.settleType !== SettleTypeEnum.OFFLINE && (
            <div>
              <div className="divider"></div>
              <div className="info-item">
                <div className="right">实收款</div>
                <div className="right">
                  ¥{" "}
                  {isReceived && orderDetail.premiumAmt
                    ? orderDetail.incomeAmt || "- -"
                    : "- -"}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {orderDetail.settleType === SettleTypeEnum.OFFLINE && (
        <div className="remind-item">
          该笔订单为线下支付订单，请与使用者线下结算
        </div>
      )}
      <div className="info-content">
        <div className="info-title">订单信息</div>
        {orderInfoList().map((item, index) => {
          return (
            <div className="info-item" key={index}>
              <div className="left">{item.name}</div>
              <div className="right">{item.value || "--"}</div>
            </div>
          );
        })}
        <div className="info-item">
          <div className="left">支付用户</div>
          <a href={`tel:${orderDetail.mobile}`}>
            <div className="right">
              <div className="nickName">{orderDetail.nickName}</div>(
              {encryptMobile(orderDetail.mobile)}
              <span style={{ color: "#5A960A", marginLeft: 5 }}>拨打</span>)
            </div>
          </a>
        </div>
      </div>
      {orderDetail.orderStatus === OrderStatusEnum.WAIT_PAY && !isMyApp && (
        <div className="remind-item" onClick={remind}>
          该笔订单尚未支付，提醒ta去支付
          <img
            src={
              "https://s.xiaopeng.com/xp-charge/charge/static/arrow-right-orange.svg"
            }
            alt=""
          />
        </div>
      )}
      <div className="info-content">
        <div className="info-title">充电信息</div>
        {chargeInfoList().map((item, index) => {
          return (
            <div className="info-item" key={index}>
              <div className="left">{item.name}</div>
              <div className="right">{item.value || "--"}</div>
            </div>
          );
        })}
      </div>
      <div className="tel">
        <ContactService text="联系在线客服" />
      </div>
      <PopupBottomModal
          visible={priceListPopupVisible}
          title="价格详情"
          onClose={() => setPriceListPopupVisible(false)}
        >
          <PriceList priceList={priceListData} isPureList/>
      </PopupBottomModal>
      <PopupModelCenter
        visible={visible}
        popupTitle={popupModelData.popupTitle}
        content={popupModelData.content}
        leftBtnText={popupModelData.leftBtnText}
        rightBtnText={popupModelData.rightBtnText}
        leftBtnFun={popupModelData.leftBtnFun}
        rightBtnFun={popupModelData.rightBtnFun}
      />
      <SharePanel
        visible={sharePanelVisible}
        onClose={() => setSharePanelVisible(false)}
        contentClassName="pile-share-panel"
        shareInfo={{
          shareMainTitle:
            "你有一笔充电订单待支付，支付后可继续畅享共享充电服务哦！",
          shareSubTitle: "",
          shareImgUrl: `${CHARGE_CDN}/sharing/mini_share_v2.jpg`,
          sharePageUrl: `pages/home-pile-order-detail/index?orderNo=${orderDetail.orderNo}&stationId=${orderDetail.stationId}`
        }}
        btns={["wx"]}
      />
    </div>
  );
};
export default OrderDetail;
